import React, { useContext, useEffect, useState } from "react";
import PageTitle from "../../components/PageTitle/PageTitle";
import {
  Box,
  Button,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Typography,
  makeStyles,
  Paper,
  Container,
} from "@material-ui/core";
import { DropzoneArea } from "material-ui-dropzone";
import ApiConfig from "../../config/ApiConfig";
import Axios from "axios";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { UserContext } from "../../context/User";
import { toast } from "react-toastify";
import CircularProgressWithBackdrop from "../../components/Loader/loader";
import Widget from "../../components/Widget/Widget";

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: theme.spacing(3),
  },
  widget: {
    background: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
    padding: theme.spacing(4),
    border: "1px solid #e0e0e0",
    marginBottom: theme.spacing(3),
  },
  header: {
    fontSize: "1.75rem",
    fontWeight: "700",
    color: "#2c3e50",
    marginBottom: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    borderBottom: "3px solid #00d4ff",
    textAlign: "center",
  },
  detailsGrid: {
    marginTop: theme.spacing(2),
  },
  detailRow: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: "8px",
    background: "#f8f9fa",
    border: "1px solid #e9ecef",
    transition: "all 0.3s ease",
    "&:hover": {
      background: "#e9ecef",
      transform: "translateY(-1px)",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  },
  label: {
    fontSize: "1rem",
    fontWeight: "600",
    color: "#495057",
    marginBottom: theme.spacing(0.5),
  },
  value: {
    fontSize: "1.1rem",
    fontWeight: "500",
    color: "#2c3e50",
    wordBreak: "break-word",
  },
  qrSection: {
    background: "#ffffff",
    borderRadius: "12px",
    padding: theme.spacing(3),
    textAlign: "center",
    border: "2px solid #e0e0e0",
    marginTop: theme.spacing(2),
  },
  qrImage: {
    maxWidth: "100%",
    maxHeight: "300px",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    border: "3px solid #ffffff",
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "scale(1.02)",
    },
  },
  qrPlaceholder: {
    padding: theme.spacing(4),
    background: "#f8f9fa",
    borderRadius: "8px",
    border: "2px dashed #dee2e6",
    color: "#6c757d",
    fontSize: "1.1rem",
    fontWeight: "500",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(4),
    paddingTop: theme.spacing(3),
    borderTop: "1px solid #e0e0e0",
  },
  button: {
    minWidth: "140px",
    height: "48px",
    background: "linear-gradient(135deg, #00d4ff 0%, #0099cc 100%)",
    color: "white",
    borderRadius: "8px",
    textTransform: "none",
    fontWeight: "600",
    fontSize: "1rem",
    boxShadow: "0 2px 8px rgba(0, 212, 255, 0.3)",
    transition: "all 0.3s ease",
    "&:hover": {
      background: "linear-gradient(135deg, #0099cc 0%, #007aa3 100%)",
      boxShadow: "0 4px 12px rgba(0, 212, 255, 0.4)",
      transform: "translateY(-2px)",
    },
  },
  infoCard: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "white",
    borderRadius: "12px",
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    textAlign: "center",
  },
  infoTitle: {
    fontSize: "1.5rem",
    fontWeight: "700",
    marginBottom: theme.spacing(1),
  },
  infoSubtitle: {
    fontSize: "1rem",
    opacity: 0.9,
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "400px",
  },
  "@media (max-width: 960px)": {
    container: {
      padding: theme.spacing(2),
    },
    widget: {
      padding: theme.spacing(2),
    },
    header: {
      fontSize: "1.5rem",
    },
    qrImage: {
      maxHeight: "250px",
    },
  },
}));

function Viewdetails(props) {
  const ContextId = useContext(UserContext);
  const history = useHistory();
  const classes = useStyles();
  const [viewdetailsqr, setViewDetailsQr] = useState(null);
  const [qrId, setQrId] = useState(ContextId.id);
  const [loader, setLoader] = useState(false);
  // console.log(props, "fsdklgjd;ogjk")

  const ViewQrCode = async () => {
    setLoader(true);
    try {
      const res = await Axios({
        method: "GET",
        url: ApiConfig.getQrById,
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("id_token")}`,
        },
        params: {
          qrId: qrId,
        },
      });

      if (res.data.status === 200) {
        setViewDetailsQr(res?.data?.data);
        setLoader(false);
      } else if (res.data.status === 404) {
        toast.error(res?.data?.message);
        history.goBack();
        setLoader(false);
      }
    } catch (error) { }
  };
  useEffect(() => {
    ViewQrCode();
  }, []);

  return (
    <>
      <PageTitle title="View Test QR Code Details" />
      {loader ? (
        <div className={classes.loadingContainer}>
          <CircularProgressWithBackdrop />
        </div>
      ) : (
        <div className={classes.container}>
          {/* Info Card */}
          {/* <div className={classes.infoCard}>
            <Typography className={classes.infoTitle}>
              QR Code Information
            </Typography>
            <Typography className={classes.infoSubtitle}>
              View detailed information about this test QR code
            </Typography>
          </div> */}

          {/* Main Details Widget */}
          <div className={classes.widget}>
            <Typography className={classes.header}>
              QR CODE DETAILS
            </Typography>
            
            <Grid container spacing={3} className={classes.detailsGrid}>
              <Grid item xs={12} md={6}>
                <div className={classes.detailRow}>
                  <Typography className={classes.label}>Test Name</Typography>
                  <Typography className={classes.value}>
                    {viewdetailsqr?.testName || "Not Available"}
                  </Typography>
                </div>
              </Grid>
              
              <Grid item xs={12} md={6}>
                <div className={classes.detailRow}>
                  <Typography className={classes.label}>Incubation Time</Typography>
                  <Typography className={classes.value}>
                    {viewdetailsqr?.incubationTime || "Not Available"} {viewdetailsqr?.data || ""}
                  </Typography>
                </div>
              </Grid>
              
              <Grid item xs={12} md={6}>
                <div className={classes.detailRow}>
                  <Typography className={classes.label}>Serial Number</Typography>
                  <Typography className={classes.value}>
                    {viewdetailsqr?.serialNumber || "Not Available"}
                  </Typography>
                </div>
              </Grid>
              
              <Grid item xs={12} md={6}>
                <div className={classes.detailRow}>
                  <Typography className={classes.label}>Batch Number</Typography>
                  <Typography className={classes.value}>
                    {viewdetailsqr?.batchNumber || "Not Available"}
                  </Typography>
                </div>
              </Grid>
              
              <Grid item xs={12} md={6}>
                <div className={classes.detailRow}>
                  <Typography className={classes.label}>LOT Number</Typography>
                  <Typography className={classes.value}>
                    {viewdetailsqr?.lotNo || "Not Available"}
                  </Typography>
                </div>
              </Grid>
              
              <Grid item xs={12} md={6}>
                <div className={classes.detailRow}>
                  <Typography className={classes.label}>Status</Typography>
                  <Typography className={classes.value} style={{ color: "#27ae60", fontWeight: "600" }}>
                    Active
                  </Typography>
                </div>
              </Grid>
            </Grid>
          </div>

          {/* QR Code Display Section */}
          <div className={classes.qrSection}>
            <Typography className={classes.label} style={{ fontSize: "1.2rem", marginBottom: "16px" }}>
              QR Code Image
            </Typography>
            {viewdetailsqr?.qrImage ? (
              <img
                src={viewdetailsqr?.qrImage}
                alt="QR Code"
                className={classes.qrImage}
              />
            ) : (
              <div className={classes.qrPlaceholder}>
                <Typography>QR Code image not available</Typography>
              </div>
            )}
          </div>

          {/* Action Button */}
          <div className={classes.buttonContainer}>
            <Button
              className={classes.button}
              variant="contained"
              onClick={() => history.push("/app/Qr")}
            >
              ← Back to QR Codes
            </Button>
          </div>
        </div>
      )}
    </>
  );
}

export default Viewdetails;
